import { useCallback, useEffect, useState } from "react";
import { getLogoURL, putLogoURL } from "../../utils/ConstantsURL";

export const useLogoStyles = (token, documentId) => {
  const [logoStyles, setLogoStyles] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [refreshIndex, setRefreshIndex] = useState(0);

  const refresh = useCallback(() => setRefreshIndex((p) => p + 1), []);

  useEffect(() => {
    if (!token || !documentId) return;
    const controller = new AbortController();
    const run = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(getLogoURL(documentId), {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          signal: controller.signal,
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data?.error || data?.message || "Error");
        setLogoStyles(data);
      } catch (e) {
        if (e.name !== "AbortError") {
          console.error("useLogoStyles get:", e);
          setError(e.message || "Error al obtener logo");
        }
      } finally {
        setLoading(false);
      }
    };
    run();
    return () => controller.abort();
  }, [token, documentId, refreshIndex]);

  const updateLogoStyles = useCallback(
    async ({ active, position, imageFile, image, width, height }) => {
      if (!documentId) {
        setError("ID de documento requerido");
        return { success: false, error: "ID de documento requerido" };
      }
      setSaving(true);
      setError(null);
      try {
        const form = new FormData();
        if (typeof active !== "undefined") form.append("active", String(active));
        if (position) form.append("position", position);
        if (width) form.append("width", String(width));
        if (height) form.append("height", String(height));
        
        if (imageFile instanceof File) {
          form.append("logoUpload", imageFile);
        } else if (image) {
          form.append("imageUrl", image);
        }

        const res = await fetch(putLogoURL(documentId), {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: form,
        });

        const data = await res.json();
        if (!res.ok) throw new Error(data?.error || data?.message || "Error");
        setLogoStyles(data);
        return { success: true, data };
      } catch (e) {
        console.error("useLogoStyles put:", e);
        const msg = e.message || "Error al actualizar logo";
        setError(msg);
        return { success: false, error: msg };
      } finally {
        setSaving(false);
      }
    },
    [token, documentId]
  );

  return { logoStyles, setLogoStyles, loading, saving, error, refresh, updateLogoStyles };
};


